import type { CreateInvoiceCommandResult, CreateInvoiceRequest } from "Api/Api";
import type { NavigateFunction } from "Navigation/useNavigate";
import { createAsyncAction } from "typesafe-actions";

import {
  CreateInvoiceCommandResultStatus,
  postInvoiceCreateInvoice,
} from "Api/Api";
import { getAppUrl } from "Utils/UrlUtils";
import { put, takeLatest } from "redux-saga/effects";
import { toast } from "sonner";
import { call } from "typed-redux-saga";
import { getType } from "typesafe-actions";

export const createInvoiceAsync = createAsyncAction(
  "@invoice/CREATE_REQUEST",
  "@invoice/CREATE_SUCCESS",
  "@invoice/CREATE_FAILURE",
)<
  { request: CreateInvoiceRequest; navigate: NavigateFunction },
  CreateInvoiceCommandResult,
  Error
>();

function* createInvoice(
  action: ReturnType<typeof createInvoiceAsync.request>,
): Generator {
  try {
    const response = yield* call(
      postInvoiceCreateInvoice,
      action.payload.request,
    );
    if (
      response.status === 200 &&
      response.json.status === CreateInvoiceCommandResultStatus.Success
    ) {
      yield put(createInvoiceAsync.success(response.json));
      toast.success("Invoice created successfully.");
      const url = getAppUrl();
      yield* call(() => action.payload.navigate(url("dashboard")));
    } else {
      yield put(
        createInvoiceAsync.failure(
          new Error(response.json.status, {
            cause: response.status,
          }),
        ),
      );
    }
  } catch (err) {
    yield put(createInvoiceAsync.failure(err as Error));
  }
}
export function* createInvoiceSaga() {
  yield takeLatest(getType(createInvoiceAsync.request), createInvoice);
}
